import { createContext } from "preact";
import { OfferServiceInterface } from "../interfaces/offer.service.interface";

export const OfferServiceContext = createContext<OfferServiceInterface | null>(null)